import { useEffect, useState } from "react";
import { TranslationService } from "../../../services/TranslationService";
import "./RedirectMessage.css";

type RedirectMessageProps = {
  providerName: string;
  onContinue: () => void;
  onCancel?: () => void;
};

export const RedirectMessage = ({
  providerName,
  onContinue,
  onCancel
}: RedirectMessageProps) => {
  const [countdown, setCountdown] = useState(3);
  const [isCancelled, setIsCancelled] = useState(false);

  useEffect(() => {
    if (isCancelled) return;

    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      onContinue();
    }
  }, [countdown, onContinue, isCancelled]);

  const handleCancel = () => {
    setIsCancelled(true);
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className="redirect-message-overlay">
      <div className="redirect-message-container">
        <div className="redirect-message-icon">
          <i className="fa-light fa-arrow-right-to-bracket"></i>
        </div>
        <h3 className="redirect-message-title">
          {TranslationService.getTranslation("RedirectingToPaymentProvider") ||
            "Redirigiendo al proveedor de pago"}
        </h3>
        <p className="redirect-message-text">
          {TranslationService.getTranslation("RedirectingMessage") ||
            `Serás redirigido a ${providerName} para completar el pago de forma segura.`}
        </p>
        <p className="redirect-message-warning">
          {TranslationService.getTranslation("RedirectingWarning") ||
            "Esta es una página externa. Una vez completado el pago, serás redirigido de vuelta."}
        </p>
        <div className="redirect-message-actions">
          {onCancel && (
            <button
              className="btn btn-secondary redirect-message-cancel"
              onClick={handleCancel}
            >
              {TranslationService.translate.Cancel || "Cancelar"}
            </button>
          )}
          <button
            className="btn btn-primary redirect-message-continue"
            onClick={onContinue}
          >
            {countdown > 0 && !isCancelled
              ? `${TranslationService.getTranslation("Continue") || "Continuar"} (${countdown})`
              : TranslationService.getTranslation("Continue") || "Continuar"}
          </button>
        </div>
      </div>
    </div>
  );
};
